/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation VendorAccountAttachCBRRoutePlanMutation($vendorAccountId: ID!, $routePlanId: [ID!]!) {
  VendorAccountAttachCBRRoutePlan(routePlanId: $routePlanId, vendorAccountId: $vendorAccountId) {
    message
    status
  }
}
`
